import styled from 'styled-components';

const Item = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
`;

const Label = styled.div`
  padding-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export { Item, Label };
